import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { getClub } from '../../../actions/profiles/clubsActions'
import { useDispatch, useSelector } from 'react-redux'

export const MenuDropdown = ({ backgroundImage, title, children }) => {
    return (
        <Dropdown className='ms-2' align="end">
            <Dropdown.Toggle as="div" className='user-dropdown-trigger'>
                <div 
                    className='user-avatar d-flex align-items-center justify-content-center'
                    style={{
                        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundColor: !backgroundImage ? 'var(--grisclaro)' : undefined
                    }}
                >
                    {!backgroundImage && <i className="fas fa-user" style={{color: 'var(--gris)', fontSize: 14}}></i>}
                </div>
                {title && <span className='d-none d-md-inline fw-medium'>{title}</span>}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {children}
            </Dropdown.Menu>
        </Dropdown>
    )
}

export const MenuDropdownClub = ({ children }) => {
    const dispatch = useDispatch()
    const [selectedOption, setSelectedOption] = useState('')
    const [clubIdSelected, setClubIdSelected] = useState(null)

    const {club} = useSelector(state=>state.clubs)

	useEffect(() => {
		const storedData = sessionStorage.getItem('dataSdplay')
		if (storedData) {
			const {clubId} = JSON.parse(storedData)
			if (clubId) setClubIdSelected(clubId)
		}
	}, [])

	useEffect(() => {
		if (clubIdSelected) {
            dispatch(getClub(clubIdSelected))
		}
	}, [clubIdSelected, dispatch])

	useEffect(() => {
		if (club) {
            setSelectedOption(club?.name)
		}
	}, [club])

    const handleSelect = (option) => {
        setSelectedOption(option)
    }

    return (
        <Dropdown onSelect={handleSelect} align="end">
            <Dropdown.Toggle as="div" className='user-dropdown-trigger'>
                <div className='user-info d-none d-md-block text-end'>
                    <div className='user-name'>{selectedOption || 'Seleccione club'}</div>
                    <div className='user-role'>Club</div>
                </div>
                <div className='avatar-menu d-flex align-items-center justify-content-center'>
                    <i className="fas fa-chevron-down" style={{fontSize: 12, color: 'var(--gris)'}}></i>
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {children}
            </Dropdown.Menu>
        </Dropdown>
    )
}